'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _set2 = require('lodash/set');

var _set3 = _interopRequireDefault(_set2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

exports.createList = createList;
exports.createItem = createItem;
exports.removeItem = removeItem;
exports.updateItem = updateItem;

var _reduxGraph = require('redux-graph');

var _capeFirebase = require('cape-firebase');

var _const = require('./const');

var _select = require('./select');

var _lang = require('./lang');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// ({ action, entityIds, firebase, next, store })

function createList(_ref) {
  var store = _ref.store,
      payload = _ref.action.payload,
      firebase = _ref.firebase,
      next = _ref.next;

  if ((0, _lang.isFavList)(payload)) {
    // Save to redux right now, so it's there for the ListItem saving.
    var item = next((0, _reduxGraph.entityPut)(payload)).payload;
    item.dateModified = firebase.TIMESTAMP;
    return (0, _capeFirebase.entityDb)(firebase.entity, item).set(item).then(function () {
      return item;
    });
  }
  return (0, _capeFirebase.entitySet)(store, payload, firebase);
}
function createItem(_ref2) {
  var payload = _ref2.action.payload,
      firebase = _ref2.firebase;

  var mainEntity = payload.mainEntity,
      item = _objectWithoutProperties(payload, ['mainEntity']);

  if (!mainEntity) throw new Error('mainEntity required. See func calling createItem.');
  var subject = (0, _reduxGraph.pickTypeId)(mainEntity);
  (0, _set3.default)(item, ['rangeIncludes', _const.PREDICATE, (0, _reduxGraph.getKey)(subject)], subject);
  // item does not have an `id` yet.
  // Save ListItem to the database.
  return (0, _capeFirebase.entitySet)(firebase, item)
  // Get dateModified value of ListItem
  // node is the saved item.
  .then(function (node) {
    return (0, _capeFirebase.entityDb)(firebase.entity, node).once('value');
  }).then(function (savedItem) {
    // yes, pickTypeId contains dateModified.
    var object = (0, _reduxGraph.pickTypeId)(savedItem.val());
    // Attach the ListItem to the CollectionList.
    (0, _capeFirebase.entityDb)(firebase.entity, subject).update(_defineProperty({
      dateModified: firebase.TIMESTAMP
    }, (0, _reduxGraph.getRefPath)(_const.PREDICATE, object).join('/'), object));
  });
}
function removeItem(_ref3) {
  var _firebase$entity$upda;

  var store = _ref3.store,
      action = _ref3.action,
      firebase = _ref3.firebase;

  // Get the full item info.
  var item = (0, _reduxGraph.getEntity)(store.getState(), action.payload);
  var list = { id: (0, _select.getListCollectionId)(item), type: _const.COLLECTION_TYPE };
  var listRefPath = (0, _reduxGraph.fullRefPath)(list, _const.PREDICATE, item).join('/');
  var listDatePath = (0, _reduxGraph.getPath)(list).concat('dateModified').join('/');
  var itemPath = (0, _reduxGraph.getPath)(item).join('/');
  // remove from list refs and remove listItem node at same time.
  // console.log(item, listId, listPath)
  return firebase.entity.update((_firebase$entity$upda = {}, _defineProperty(_firebase$entity$upda, listRefPath, null), _defineProperty(_firebase$entity$upda, listDatePath, firebase.TIMESTAMP), _defineProperty(_firebase$entity$upda, itemPath, null), _firebase$entity$upda));
}
function updateItem(_ref4) {
  var store = _ref4.store,
      _ref4$action = _ref4.action,
      meta = _ref4$action.meta,
      payload = _ref4$action.payload,
      firebase = _ref4.firebase;

  if ((0, _get3.default)(meta, 'action') === 'END_ITEM') return removeItem(store, payload, firebase);
  return (0, _capeFirebase.entityUpdate)(firebase, payload);
}


//////////////////
// WEBPACK FOOTER
// ./~/cape-redux-collection/lib/entityUpdate.js
// module id = 834
// module chunks = 0